var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"heard"},[_c('img',{attrs:{"src":require("./img/icon1.png")}}),_c('span',{domProps:{"textContent":_vm._s(_vm.name)}}),_c('a',{staticClass:"more"}),_c('a',{staticClass:"message"})])}
var staticRenderFns = []

export { render, staticRenderFns }